import { BannersContent, SharedBannersContentItem, ContentType } from 'api/placements-api';

const isBannersContent = (content: BannersContent | SharedBannersContentItem[]): content is BannersContent =>
  !Array.isArray(content);

export const enrichContent = (
  content: BannersContent | SharedBannersContentItem[],
  contentType: ContentType
): SharedBannersContentItem[] => {
  if (contentType === ContentType.BANNERS && isBannersContent(content)) {
    return content.banners.map(banner => ({
      id: content.id,
      banner,
      ord: content.ord,
    }));
  }

  if (!isBannersContent(content) && contentType === ContentType.SHARED_BANNERS) {
    return content;
  }

  throw new Error('Content has not valid ContentType');
};
